<template>
  <Modal
    ref="singleProductSuccessModalRef"
    @onPositiveActionClick="singleProductSuccessConfirm()"
    @modalClosed="singleProductSuccessConfirm()"
    positiveActionText="Ürün Yönetimine Git"
    class="singleProductSuccessModal"
    type="success"
    withCloser="true"
  >
    <template v-slot:body>
      <div class="singleProductSuccessModal-context">
        <h2 class="singleProductSuccessModal-title">Ürününüz eklendi.</h2>
        <p class="singleProductSuccessModal-content">Katalog onayından sonra satışa açılacaktır. Detaylarını Ürün Yönetimi sayfasından takip edebilirsiniz.</p>
      </div>
    </template>
  </Modal>
</template>

<script setup>
import { ref } from "vue";
import { Modal } from "@n11/so-ui-components";
const singleProductSuccessModalRef = ref();

const singleProductSuccessConfirm = () => {
  return window.location = '/selleroffice/v2/product/products';
};

const openProductSuccessModal = () => singleProductSuccessModalRef?.value?.openModal();

defineExpose({
  openProductSuccessModal,
})

</script>

<style lang="scss" scoped>
.singleProductSuccessModal {
  &-title {
    font-size: 20px;
    font-weight: 700;
    text-align: center;
    line-height: 26px;
    margin-bottom: 0;
  }

  &-context {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 32px;
    padding-bottom: 16px;

    p {
      line-height: 24px;
      letter-spacing: -0.2px;

      b {
        font-weight: bold;
      }
    }
  }
}
</style>
